import React, { Component } from 'react'
import { arrayOf } from '../../../../utils/StoreUtils'
import i18n from 'simple-react-i18n'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import Checkbox from '../../../../components/forms/Checkbox'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { connect } from 'react-redux'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { normalizeString } from '../../../../utils/StringUtil'
import SelectionTableModal from '../../../../components/modal/SelectionTableModal'
import DtoParametrageDataType from '../../../../piezometry/dto/DtoParametrageDataType'
import AppStore from '../../../../store/AppStore'
import CityAction from '../../../../referencial/components/city/actions/CityAction'
import PluviometryAction from '../../../../pluviometry/actions/PluviometryAction'
import RadioButtons from '../../../../components/forms/RadioButtons'
import AdesStationDto from '../../../dto/AdesStationDto'
import { nbPerPageLabelTiny } from '../../../../referencial/constants/ReferencialConstants'
import { uniq } from 'lodash'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import { Buffer } from 'buffer'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { Grid, Button } from '@mui/material'
import { CITIES, DEPARTMENTS, STATIONS } from 'traitements/constants/TraitementConstants'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { CardTable } from 'components/datatable/NewTable'
import { darkBlue, mainWhite } from 'utils/constants/ColorTheme'
import { exportFile } from 'utils/ExportDataUtil'

class MeteoFrancePanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cityPopupOpen: false,
        }
    }

    componentDidMount() {
        if (!this.props.cities.length) {
            AppStore.dispatch(CityAction.fetchCities())
        }
        if (!this.props.pluviometryDataTypes.length) {
            AppStore.dispatch(PluviometryAction.fetchPluviometryDataTypes())
        }
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return {
            cities: [],
            daily: true,
            rain: true,
            importMode: 'DATA_ADD_LAST_DATA',
            takePrincipal: true,
            codeMode: 'stations',
            closedStationYears: 2,
            ...newFilters }
    }

    onImportFile = e => {
        if (this.props.isEditMode) {
            const reader = new FileReader()
            const file = e.target.files[0]
            reader.onload = upload => {
                const split = upload.target.result.split(',')
                if (split[0].indexOf('text/csv') > 0 || split[0].indexOf('vnd.ms-excel') > 0) {
                    const buf = Buffer.from(split[1], 'base64').toString()
                    const codes = buf.replace(/;/g, '').split('\n').map(b => b.trim())
                    const filteredCodes = codes.filter((c) => c !== '')
                    const filters = this.getFilters()
                    if (filters.codeMode === 'departments') {
                        this.onChangeFilters({ departmentCodes: uniq([ ...(filters.departmentCodes ?? []), ...filteredCodes ]) })
                    } else {
                        this.onChangeFilters({ stationCodes: uniq([ ...(filters.stationCodes ?? []), ...filteredCodes ]) })
                    }
                } else {
                    AppStore.dispatch(ToastrAction.error(i18n.theSelectedFileMustBeInCsvFormat))
                }
                e.target.value = ''
            }
            reader.readAsDataURL(file)
        }
    }

    addCode = () => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            const previousList = filters.codeMode === DEPARTMENTS ? filters.departmentCodes ?? [] : filters.stationCodes ?? []
            const code = this.refs.txtAddBssCode.value
            const exist = previousList.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisCode))
            } else {
                if (filters.codeMode === DEPARTMENTS) {
                    this.onChangeFilters({ departmentCodes: [ code, ...(filters.departmentCodes ?? []) ] })
                } else {
                    this.onChangeFilters({ stationCodes: [ code, ...(filters.stationCodes ?? []) ] })
                }
                this.refs.txtAddBssCode.value = ''
            }
        }
    }

    getStations = () => {
        const filters = this.getFilters()
        if (filters.codeMode === DEPARTMENTS) {
            return (filters.departmentCodes ?? []).map(bsscode => new AdesStationDto({ bsscode }))
        }
        return (filters.stationCodes ?? []).map(bsscode => new AdesStationDto({ bsscode }))
    }

    onDeleteBssCode = ({ bsscode }) => {
        const filters = this.getFilters()
        if (filters.codeMode === DEPARTMENTS) {
            this.onChangeFilters({ departmentCodes: filters.departmentCodes.filter(p => p !== bsscode) })
        } else {
            this.onChangeFilters({ stationCodes: filters.stationCodes.filter(p => p !== bsscode) })
        }
    }

    render() {
        const disabled = !this.props.isEditMode
        const filters = this.getFilters()
        const codesTypes = [
            { code: STATIONS, name: i18n.stations },
            { code: CITIES, name: i18n.cities },
            { code: DEPARTMENTS, name: i18n.departments },
        ]
        return (
            <>
                <StyledFieldSet>
                    <StyledLegend>{i18n.dataTypes}</StyledLegend>
                    <Grid container justifyContent='space-between' spacing={2} sx={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <Grid size={3}>
                            <Checkbox
                                checked={ filters.rain }
                                label={ i18n.rain }
                                onChange={ v => this.onChangeFilters({ ['rain']: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Checkbox
                                checked={ filters.radiation }
                                label={ i18n.radiation }
                                onChange={ v => this.onChangeFilters({ ['radiation']: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Checkbox
                                checked={ filters.temperature }
                                label={ i18n.temperature }
                                onChange={ v => this.onChangeFilters({ ['temperature']: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Checkbox
                                checked={ filters.etp }
                                label={ i18n.etp }
                                onChange={ v => this.onChangeFilters({ ['etp']: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet>
                    <StyledLegend>{ i18n.parameters }</StyledLegend>
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid size={3}>
                            <Select
                                options={ getIntegrationModes() }
                                obligatory={true}
                                label={ i18n.dataIntegration }
                                value={ filters.importMode }
                                labelSpan={ <IntegrationModeDialog /> }
                                onChange={ v => this.onChangeFilters({ importMode: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <RadioButtons
                                elements={codesTypes}
                                selected={filters.codeMode}
                                onChange={v => this.onChangeFilters({ codeMode: v })}
                                title={i18n.schemeAgencyID}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid size={2}>
                            <SimpleDatePicker
                                label={i18n.startDate}
                                value={filters.startDate}
                                onChange={date => this.onChangeFilters({ startDate: date })}
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={4}>
                            <Checkbox
                                checked={ filters.doNotImportClosedStations }
                                label={ i18n.doNotImportClosedStations }
                                onChange={ v => this.onChangeFilters({ doNotImportClosedStations: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        { filters.doNotImportClosedStations ? (
                            <Grid size={3}>
                                <Input
                                    type='number'
                                    title={ i18n.closedStationYears }
                                    value={ filters.closedStationYears ?? 2 }
                                    onChange={ v => this.onChangeFilters({ closedStationYears: Number(v) }) }
                                    disabled={ disabled }
                                />
                            </Grid>
                        ) : null }
                    </Grid>
                </StyledFieldSet>
                {
                    filters.codeMode === STATIONS || filters.codeMode === DEPARTMENTS ? (
                        <>
                            <Grid container mt={2} mb={2} justifyContent='space-between' spacing={2}>
                                <Grid size={3}>
                                    <label>{ i18n.importFile }</label>
                                </Grid>
                                <Grid size={6}>
                                    <Button
                                        variant='contained'
                                        component='label'
                                        disabled={ disabled }
                                        sx={{ padding: '5px', fontSize: '14px' }}
                                    >
                                        {i18n.importLabelStation}
                                        <input
                                            type='file'
                                            accept='.csv'
                                            hidden
                                            onChange={this.onImportFile}
                                        />
                                    </Button>
                                </Grid>
                                <Grid size={3} />
                            </Grid>
                            <Grid container mt={2} mb={2} justifyContent='space-between' spacing={2}>
                                <Grid size={3}>
                                    <label>{ i18n.addCredential }</label>
                                </Grid>
                                <Grid size={5}>
                                    <input
                                        id='txtAddBssCode' type='text'
                                        placeholder={ i18n.BSSExample }
                                        ref='txtAddBssCode'
                                        disabled={ disabled }
                                    />
                                    <label className='tinyLabel'>{ i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode }</label>
                                </Grid>
                                <Grid size={4}>
                                    <Grid container>
                                        <Grid size={3} offset={1}>
                                            <a
                                                className='waves-effect waves-light btn'
                                                onClick={ this.addCode }
                                                disabled={ disabled }
                                            >
                                                { i18n.add }
                                            </a>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container mt={2} mb={2} justifyContent='space-between' spacing={2}>
                                <Grid size={12}>
                                    <CardTable
                                        headers={ ['bsscode'] }
                                        rows={ this.getStations() }
                                        title={i18n.credentials}
                                        rowsPerPageOptions={ nbPerPageLabelTiny }
                                        lineActions={[
                                            { icon: 'delete', onClick: this.onDeleteBssCode, displayed: this.props.isEditMode },
                                        ]}
                                        actions={[{
                                            icon: 'download',
                                            onClick: () => exportFile({
                                                data: this.getStations(),
                                                titleFile: i18n.credentials,
                                            }),
                                            color: mainWhite,
                                            tooltip: i18n.download,
                                        }]}
                                        exportButtonOnHeader
                                        color={darkBlue}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    ) : undefined
                }
                {
                    filters.codeMode === CITIES ? (
                        <>
                            <StyledFieldSet>
                                <StyledLegend>{ i18n.cities }</StyledLegend>
                                <Grid size={4}>
                                    <Button
                                        variant='contained'
                                        onClick={ () => this.setState({ cityPopupOpen: true })}
                                    >
                                        { `${(filters.cityCodes ?? []).length} ${i18n.cities}` }
                                    </Button>
                                </Grid>
                            </StyledFieldSet>
                            <SelectionTableModal
                                isOpen={this.state.cityPopupOpen}
                                onClose={() => this.setState({ cityPopupOpen: false })}
                                onValidate={list => {
                                    this.onChangeFilters({ cityCodes: list })
                                    this.setState({ cityPopupOpen: false })
                                }}
                                title={i18n.cities}

                                listData={this.props.cities}
                                defaultSelectionList={filters.cityCodes ?? []}

                                listHeaders={['code', 'name']}
                                listTitle={i18n.cities}
                                selectionListTitle={i18n.selectedElements}
                                maxHeightTable={'48vh'}

                                filterField={({
                                    filter,
                                    setFilter,
                                }) => (
                                    <Grid container sx={{ padding: '10px 0px' }}>
                                        <Grid size={6}>
                                            <Input
                                                title={i18n.search}
                                                value={filter.searchValue}
                                                onChange={searchValue => setFilter(prev => ({ ...prev, searchValue }))}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                filterFunction={(list, { searchValue }) => {
                                    const searchValueFormat = normalizeString(searchValue)
                                    return searchValue ? list.filter(p => normalizeString([p.code, p.name].join('   ')).includes(searchValueFormat)) : list
                                }}
                            />
                        </>
                    ) : undefined
                }
            </>
        )
    }
}

MeteoFrancePanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    cities: arrayOf(CityDto),
    pluviometryDataTypes: arrayOf(DtoParametrageDataType),
}

const mapStateToProps = store => ({
    cities: store.CityReducer.cities,
    pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
})

export default connect(mapStateToProps)(MeteoFrancePanel)